// removed by extract-text-webpack-plugin
module.exports = {"hidden":"RdmMb","visuallyhidden":"oNUPL","hide-text":"_1Tof_","center":"_2-QlC","noprint":"bf6uq","articlesList":"_3igrR","listItem":"_3945n","article":"_30s5-","articleLink":"W4_ic","root":"_10Pby"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-article-list/styles/default.scss
 ** module id = 985
 ** module chunks = 2
 **/